// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';
import { BOLD, REGULAR, SEMIBOLD } from '../../../helpers/fontWeight';

export const FromPrice = styled<any, Theme>('span')`
  color: ${props => props.theme.carblock.fromPrice.color};
  font-size: ${props => props.theme.carblock.fromPrice.fontSize};
  font-weight: ${SEMIBOLD};
  margin-right: 1rem;
  position: relative;

  &::after {
    background-color: currentColor;
    content: '';
    display: block;
    height: 1px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%) rotate(-12deg);
    width: 100%;
  }
`;

export const DiscountPrice = styled<any, Theme>('span')`
  color: ${props => props.theme.carblock.price.color};
  font-size: ${props => props.theme.carblock.price.fontSize.default};
  font-weight: ${BOLD};
  margin-right: 1rem;
`;

export const PriceContainer = styled<any, Theme>('section')`
  align-items: center;
  display: flex;
  justify-content: ${props => props.theme.carblock.priceJustifyContent};
  padding: .25rem 0;
`;

export const Payment = styled<any, Theme>('span')`
  color: ${props => props.theme.carblock.color};
  font-size: ${props => props.theme.carblock.payment.fontSize};
  font-weight: ${REGULAR};
  line-height: 1;
  max-width: ${props => props.theme.carblock.payment.width};

  &::first-line {
    font-size: ${props => props.theme.carblock.payment.firstLineFontSize};
  }
`;

type Props = {
  from?: ?string,
  price: string,
  payment: string,
};

const Price = ({ from, price, payment }: Props) => (
  <PriceContainer>
    {from && (<FromPrice>{from}</FromPrice>)}
    <DiscountPrice>{price}</DiscountPrice>
    <Payment>{payment}</Payment>
  </PriceContainer>
);

Price.defaultProps = {
  from: null,
};

export default Price;
